<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-data-table
            :footer-props="datatable_footer"
            :headers="headers"
            :items="cards"
            :options.sync="table_options"
            :server-items-length="total"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:top>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <autocomplete
                        ref="autocomplete"

                        :get-result-value="getResultValue"
                        :search="search"
                        @submit="onSubmit"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      sm="2"
                    >
                      <v-btn
                        class="ma-0"
                        color="primary"
                        outlined
                        @click="onOpenFilter"
                      >
                        <v-icon class="ml-3">
                          mdi-filter-variant
                        </v-icon>
                        <span class="mx-3">ФИЛЬТРЫ</span>
                      </v-btn>
                    </v-col>
                    <v-col
                      class="d-flex justify-md-end"
                      cols="12"
                      md="7"
                    >
                      <v-btn
                        class="ma-0"
                        color="secondary"
                        outlined
                        @click="onDownloadReport"
                      >
                        <v-icon class="ml-3">
                          mdi-download
                        </v-icon>
                        <span class="mx-3">Выгрузить</span>
                      </v-btn>
                      <v-icon
                        class="icon-table"
                        medium
                        @click="onOpenHeader"
                      >
                        mdi-table-cog
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <div>
                      <v-chip
                        v-for="(filter, index) in filterStuff"
                        v-show="filter.fieldTitle !== '' "
                        :key="'i' + index"
                        close
                        @click:close="onClearFilter(filter)"
                      >
                        <span>{{ filter.fieldTitle }}</span>
                      </v-chip>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.operation="{ item }">
              <v-chip
                :color="item.operation.color"
              >
                {{ item.operation.text }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="item.status.color"
              >
                {{ item.status.text }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <filter-dialog
          :dialog-visible="filterDialogVisible"
          :filter-label="filterLabel"
          :filter-stuff="filterStuff"
          @close="onCloseFilter"
          @filter="onSetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <header-dialog
          :dialog-headers="dialogHeaders"
          :dialog-visible="headerDialogVisible"
          @close="onCloseHeader"
          @header="onSetHeader"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import FilterDialog from "@/views/loyalty/shared/components/filter/FilterDialog.vue"
import HeaderDialog from "@/views/loyalty/shared/components/header/HeaderDialog.vue"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete.vue"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"
import { ParticipantService } from "@/views/loyalty/shared/services/participant_service"
import { HeaderService } from "@/views/loyalty/shared/services/header_service"
import {
    CardHeadersModel,
    CardModel,
    CardTitlesModel
} from "@/views/loyalty/models/card.model"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { downloadCsvFile, getCsvFile, getSearchedObjects } from "@/views/loyalty/shared/modules/utilities"
import { clearFilter, FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"
import { CardService } from "@/views/loyalty/shared/services/card-service"
import { JustpayUser } from "@/views/loyalty/shared/services/justpay-user-service"

export default {
    name: "CardList",
    campaigns: [],
    components: { Autocomplete, FilterDialog, HeaderDialog },
    data: () => ({
        cardService: null,
        customerNumber: null,
        datatable_footer: {
            itemsPerPageText: 'Показывать по',
            pageText: 'из',
            itemsPerPageAllText: 'Все',
        },
        dialogHeaders: [],
        filterDialogVisible: false,
        filterLabel: 'card.filter',
        filterStuff: [],
        headerDialogVisible: false,
        headers: [],
        headerService: null,
        justpayClientService: null,
        justpayUser: null,
        participants: [],
        products: [],
        role: 0,
        servicePoints: [],
        searchStuff: null,
        table_options: {},
        total: 0,
        cards: [],
        userProfile: null,
        webApi: null
    }),
    watch: {
        table_options: {
            async handler () {
                console.log(this.table_options)
                const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
                this.cards = await this.getItems()
            },
            deep: true,
        },
    },
    async beforeMount () {
        this.role = +this.$route.params.role
        this.cardService = new CardService()
        this.justpayUser = new JustpayUser()
        this.userProfile = new Userprofile()
        let users = await this.justpayUser.getUsers()

        console.log('users', users)
        if (!users.error) {
            // Resolve Participant Id to Full Name
            const participantService = new ParticipantService()
            this.participants = users.data.map(m => {
                participantService.add_data(m)
                return participantService.item
            })
            console.log('participants', this.participants)
        }
        if (this.role === 1) {
            users = await this.userProfile.getUserProfileAll()
            console.log('users', users)
            const participantService = new ParticipantService()
            const userProfiles = users.map(m => {
                participantService.add_data(m)
                return participantService.item
            })
            this.participants = [...this.participants, ...userProfiles]
            console.log('participants', this.participants)
        }

        localStorage.removeItem(this.filterLabel)
        this.headerService = new HeaderService(CardHeadersModel)
        this.webApi = new WebApi().readError("Ошибка при чтении данных")
        const data = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/card/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
        console.log('header data', data)
        this.dialogHeaders = this.headerService.get_header(data)
        console.log('that.dialogHeaders', this.dialogHeaders)
        this.headers = this.headerService.get_header_list(data)
        console.log('that.headers', this.headers)

        this.fillFilterStuff()
        this.fillSearchStuff()
        this.cards = await this.getItems()
        // console.log('this.cards', this.cards)
    },
    methods: {
        // createItem () {
        //     this.$router.push({ name: "CardCustomerEditLink" })
        // },
        onDownloadReport () {
            console.log("card", this.cards)
            let csv =
                "Участник;Номер карты;Срок обслуживания;Хэш карты;Тип операции;Последняя дата изменения;\n"
            csv += getCsvFile(this.cards)
            console.log("csv", csv)
            downloadCsvFile("ReportCard", csv)
        },
        fillFilterStuff () {
            this.filterStuff = new FilterStuff()
            CardTitlesModel.forEach(item => this.filterStuff.add(new FilterItem().fieldKey(item.value).fieldName(item.text).fieldValue("").fieldType(item.filterType).fieldValues(item.filterValues).fieldMoney().fieldDate().fieldTitle("").value))
            this.filterStuff = this.filterStuff.items
            console.log('fillFilterStuff filterStuff', this.filterStuff)
            return this.filterStuff
        },
        fillSearchStuff () {
            this.searchStuff = Object.assign({}, SearchStuffModel)
            this.searchStuff.fieldNames = CardTitlesModel.map(m => Object.fromEntries(Object.entries(m).filter(([key, value]) => {
                if (key === 'value' || key === 'filterType') {
                    return value
                }
            }))) // .map(obj => obj.value)
            console.log('this.searchStuff:', this.searchStuff)
        },
        async getItems () {
            const filterStuff = this.filterStuff.filter(f => f.fieldValue.toString().length > 0 || Object.keys(f.fieldDate).length > 0 || Object.keys(f.fieldMoney).length > 0)
                .map(fs => Object.fromEntries(Object.entries(fs).filter(([key]) => [
                    'fieldValue', 'fieldDate', 'fieldMoney', 'fieldType', 'fieldKey'].includes(key)
                )))
            console.log('getItems filterStuff', filterStuff)
            const cards = await this.cardService.getCards(this.table_options.page, this.table_options.itemsPerPage, filterStuff, this.searchStuff)
            console.log('cards', cards)
            this.total = cards.count
            return cards.items.map(item => {
                // set name instead id for participant in transaction table
                this.participants.map(sp => {
                    if (sp.userId === item.userId) {
                        Reflect.set(item, 'userId', sp.fullName)
                    }
                })
                return this.setItems(item)
            })
        },
        getResultValue (result) {
            return result.searched
        },
        onClearFilter (filter) {
            console.log('filter', filter)
            const attrFilter = JSON.parse(localStorage.getItem(this.filterLabel))
            console.log('attrFilter', attrFilter)
            const newFilter = clearFilter(attrFilter, filter)
            console.log('newFilter', newFilter)
            localStorage.setItem(this.filterLabel, JSON.stringify(newFilter))
            this.onSetFilter()
        },
        onCloseFilter () {
            const filterStuff = JSON.parse(localStorage.getItem(this.filterLabel))
            console.log('const filterStuff', filterStuff)
            this.filterStuff = filterStuff || this.fillFilterStuff()
            console.log('onCloseFilter this.filterStuff', this.filterStuff)
            this.filterDialogVisible = false
        },
        onCloseHeader () {
            this.headerDialogVisible = false
        },
        onOpenFilter () {
            this.filterDialogVisible = true
        },
        onOpenHeader () {
            const that = this
            this.headerDialogVisible = true
            this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/header/card/${this.$store.state.client ? this.$store.state.client.id : "0"}`)
                .then(function (data) {
                    console.log('header data', data)
                    that.dialogHeaders = that.headerService.get_header(data)
                })
        },
        async onSetFilter () {
            this.filterStuff = JSON.parse(localStorage.getItem(this.filterLabel)) || this.fillFilterStuff()
            // console.log('attrFilter', attrFilter)
            this.filterDialogVisible = false
            // this.filterStuff = new FilterStuff(attrFilter).items
            console.log('this.filterStuff', this.filterStuff)
            this.cards = await this.getItems()
        },
        onSetHeader (value) {
            console.log('onSetHeader', value)
            this.dialogHeaders = value
            this.headerDialogVisible = false
            const headers = this.headerService.set_header("card", this.$store.state.client ? this.$store.state.client.id : "0", value)
            console.log('headers', headers)
            this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/header/`, headers)
            this.headers = this.headerService.get_header_list(headers)
        },
        async onSubmit (result) {
            const searching = result.searched ? result.searched : result
            console.log('searching:', searching)
            if (searching.length !== 0) {
                // this.cards = getObjectsForSearching(this.cards, searching)
                this.searchStuff.fieldValue = searching
                this.cards = await this.getItems()
            } else {
                this.searchStuff.fieldValue = ''
                await this.onSetFilter()
            }
        },
        search (input) {
            console.log('search', input)
            if (input.length < 1) {
                return []
            }
            const arr = getSearchedObjects(this.cards, input)
            console.log('arr', arr)
            return arr
        },
        setItems (data) {
            return Reflect.construct(CardModel, [data])
        }
    }
}
</script>
<style scoped>

</style>
